import { type AgnosticShipper } from 'core/domain/AgnosticShipper'

export type RawAgnosticShipper = {
  company_name: string
  id: number
}

export function mapApiToShipper(shipper: RawAgnosticShipper): AgnosticShipper {
  const { company_name, id } = shipper
  return {
    companyName: company_name,
    id,
  }
}
